/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Publish_Done_Reenable_PortalsInputs */

const cs_property_publish_done_reenable_portals = /** @type {(inputs: Property_Publish_Done_Reenable_PortalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publikováno na webu. Portály znovu zapněte na záložce Portály.`)
};

const en_property_publish_done_reenable_portals = /** @type {(inputs: Property_Publish_Done_Reenable_PortalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Published on the website. Re-enable portals on the Portals tab.`)
};

/**
* | output |
* | --- |
* | "Published on the website. Re-enable portals on the Portals tab." |
*
* @param {Property_Publish_Done_Reenable_PortalsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_publish_done_reenable_portals = /** @type {((inputs?: Property_Publish_Done_Reenable_PortalsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Publish_Done_Reenable_PortalsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_publish_done_reenable_portals(inputs)
	return cs_property_publish_done_reenable_portals(inputs)
});